import { TaskDate } from 'src/core/master-data/domain/task-date';
import { LocalDate } from './local-date';
import * as moment from 'moment-timezone';

export class DateHelper {
  static expectedDate(date: TaskDate, expectedDateString: string = ''): string {
    const expected = date.expected;
    const from = date.range.from;
    const to = date.range.to;
    const rangeInSameDay = from.date.isSame(to.date, 'day');
    const completeDays =
      from.toFormat('HH:mm') === '00:00' && (to.toFormat('HH:mm') === '00:00' || to.toFormat('HH:mm') === '23:59');

    if (rangeInSameDay) {
      const sameHour = from.toFormat('HH:mm') === to.toFormat('HH:mm');
      if (completeDays) {
        return `${expected.toFormat('DD/MM')}`;
      }
      if (sameHour) {
        return `${expected.toFormat('DD/MM')} (${from.toFormat('H:mm')})`;
      }
      return `${expected.toFormat('DD/MM')} (${from.toFormat('H:mm')} - ${to.toFormat('H:mm')})`;
    }

    return completeDays
      ? `${from.toFormat('DD/MM')} - ${to.toFormat('DD/MM')} (${expectedDateString}: ${expected.toFormat('DD/MM')})`
      : `${from.toFormat('DD/MM H:mm')} - ${to.toFormat('DD/MM H:mm')} (${expectedDateString}: ${expected.toFormat(
          'DD/MM'
        )})`;
  }

  static thisWeekRange(): { from: string; to: string } {
    moment.locale('es');
    return {
      from: LocalDate.fromIsoString(moment().startOf('week').format()).ymd,
      to: LocalDate.fromIsoString(moment().endOf('week').format()).ymd,
    };
  }

  static thisMonthRange(): { from: string; to: string } {
    moment.locale('es');
    return {
      from: LocalDate.fromIsoString(moment().startOf('month').format()).ymd,
      to: LocalDate.fromIsoString(moment().endOf('month').format()).ymd,
    };
  }

  static lastMonthRange(): { from: string; to: string } {
    moment.locale('es');
    return {
      from: LocalDate.fromIsoString(moment().subtract(1, 'month').startOf('month').format()).ymd,
      to: LocalDate.fromIsoString(moment().subtract(1, 'month').endOf('month').format()).ymd,
    };
  }

  static threeMonthsBeforeAndAfterRange(): { from: string; to: string } {
    moment.locale('es');
    return {
      from: LocalDate.fromIsoString(moment().startOf('month').subtract(3, 'month').startOf('month').format()).ymd,
      to: LocalDate.fromIsoString(moment().startOf('month').add(3, 'month').endOf('month').format()).ymd,
    };
  }
}
